module.exports = __webpack_public_path__ + "fonts/fa-duotone-900.6383c1d5.woff";